import { render, staticRenderFns } from "./profile-progressbar.vue?vue&type=template&id=6a5e8fe6&"
import script from "./profile-progressbar.vue?vue&type=script&lang=ts&"
export * from "./profile-progressbar.vue?vue&type=script&lang=ts&"
import style0 from "./profile-progressbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports